<div class="h-screen w-screen flex flex-col bgcolor-gray-sys">
  <template-navbar></template-navbar>
  <div class="flex-1 flex justify-between">
    @if (!layoutExpandido) {
      <template-sidebar></template-sidebar>
    }
    <div class="h-full flex-1 overflow-auto pt-6 pl-3 pr-7">
      @if (layoutExpandido) {
        <div class="expandido-toolbar">
          <button class="btn-icon" (click)="voltar()" matTooltip="Voltar para a home">
            <mat-icon>arrow_back</mat-icon>
          </button>
        </div>
      }
      <router-outlet />
    </div>
  </div>
  <div class="footer text-center pt-1.5 pb-0.5">
    <img
      class="scale-75"
      src="images/logo/logo-prolins-gray.png"
      alt="Logo Prolins"
    />
  </div>
</div>
